var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHaluAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 211,
    fill: "none",
    viewBox: "0 0 400 211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E1F67",
    stroke: "#2E1F67",
    strokeWidth: 7,
    d: "M165.197 154.75 250.5 7l85.304 147.75H165.197Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D31F1F",
    d: "M210.682 129.8c0-4.28-1.76-6.8-6.52-6.8h-8.64v6.28h13.4V132h-8.04c-3.72 0-5.8 2.4-5.8 5.84 0 3.12 2.24 5.76 6.2 5.76 3.16 0 6.36-1.8 7.64-4.52V143h6.32v-6.4h-4.56v-6.8Zm-13.56 6.8c0-.76.52-1.52 1.04-2 .68-.64 2.04-.96 3.08-.96h7.68v2.96h-11.8Zm33.121-14.2c-3.04 0-5.56 1.56-6.64 3.84V115.6h-6.32v6.4h4.56v14.6h-4.56v6.4h6.32v-3.24c1.08 2.28 3.6 3.84 6.64 3.84 4.04 0 7.2-2.76 7.2-6.4v-8.4c0-3.64-3.16-6.4-7.2-6.4Zm-6.64 14.2v-7.2h12.08v7.2h-12.08Zm34.153-7.2c0-4.08-3.28-7-7.8-7s-7.8 2.92-7.8 7v7.2c0 4.08 3.44 7 7.8 7 4.56 0 7.8-2.92 7.8-7v-7.2Zm-1.76 0v7.2h-12.08v-7.2h12.08Zm29.674-6.4h-10.88v6.4h4.56v7.2h-12.08v-7.2h4.6V123h-10.88v6.4h4.52v7.2c0 4 2.92 7 7.2 7 2.92 0 5.52-1.72 6.64-4.28V143h6.32v-6.4h-4.56v-7.2h4.56V123Zm10.569 8.8h9.68V126h-9.68v-10.4h-6.32v6.4h4.56v4h-4.56v5.8h4.56v5.52c0 3.76 2.64 6.28 6.04 6.28 3.36 0 5.96-2.52 5.96-5.88v-1.12h-10.24v-4.8Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaluAbout);
export default __webpack_public_path__ + "static/media/halu-about.70207aba9e3d5d93c12c1914b147ef73.svg";
export { ForwardRef as ReactComponent };